import { PAY_NOW_SUCCESS } from 'actions/checkout'
import { LOGIN_SUCCESS } from 'actions/login'
import { LOGOUT_SUCCESS } from 'actions/logout'
import {
  DISMISS_ERROR,
  FETCH_CATEGORIES_FAILURE,
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORY_PARENTS_FAILURE,
  FETCH_CATEGORY_PARENTS_REQUEST,
  FETCH_CATEGORY_PARENTS_SUCCESS,
  FETCH_CATEGORY_VIDEOS_SUCCESS,
  FETCH_MORE_VIDEOS_FAILURE,
  FETCH_MORE_VIDEOS_REQUEST,
  FETCH_MORE_VIDEOS_SUCCESS,
  FETCH_VIDEOS_FAILURE,
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
  INIT_APP_REQUEST,
  SET_FOCUSED_POSITION,
  SET_FOCUSED_SECTION,
} from '../actions/video-category'

const INITIAL_STATE = {
  isReady: false,
  isParentsReady: false,
  isVideosReady: false,
  isCategoriesReady: false,
  shouldLoadMoreVideos: true,
  hasError: false,
  errorMessage: '',
  parents: [],
  videos: [],
  categories: [],
  categoryVideos: {},
  focusedSection: '',
  focusedPosition: {},
  byId: {},
  overview: {
    type: 'unknown',
    id: -1,
  },
}

const videoLibraryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INIT_APP_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
        focusedSection: '',
        focusedPosition: {},
        overview: {
          type: 'unknown',
          id: -1,
        },
      }

    case FETCH_CATEGORY_PARENTS_REQUEST:
      return {
        ...state,
        isReady: false,
        isParentsReady: false,
      }
    case FETCH_CATEGORY_PARENTS_SUCCESS:
      return {
        ...state,
        isReady: state.isCategoriesReady && state.isVideosReady,
        isParentsReady: true,
        parents: action.payload,
      }
    case FETCH_CATEGORY_PARENTS_FAILURE:
      return {
        ...state,
        isReady: state.isCategoriesReady && state.isVideosReady,
        isParentsReady: true,
      }

    case FETCH_VIDEOS_REQUEST:
      return {
        ...state,
        isReady: false,
        isVideosReady: false,
      }
    case FETCH_VIDEOS_SUCCESS:
      return {
        ...state,
        isReady: state.isParentsReady && state.isCategoriesReady,
        isVideosReady: true,
        videos: action.payload.map(video => video.id),
        byId: newById(state, action.payload),
        focusedSection: action.payload.length > 0 ? 'videos' : state.focusedSection,
        focusedPosition: {
          ...state.focusedPosition,
          videos: 0,
        },
        overview:
          action.payload.length > 0
            ? {
                type: 'video',
                id: action.payload[0].id,
              }
            : {
                ...state.overview,
              },
        shouldLoadMoreVideos: action.payload.length > 0,
      }
    case FETCH_VIDEOS_FAILURE:
      return {
        ...state,
        isReady: state.isParentsReady && state.isCategoriesReady,
        isVideosReady: true,
        shouldLoadMoreVideos: false,
      }

    case FETCH_MORE_VIDEOS_REQUEST:
      return {
        ...state,
        shouldLoadMoreVideos: false,
      }
    case FETCH_MORE_VIDEOS_SUCCESS:
      return {
        ...state,
        shouldLoadMoreVideos: action.payload.length > 0,
        videos: state.videos.concat(action.payload.map(video => video.id)),
        byId: newById(state, action.payload),
        overview:
          state.overview.type === 'unknown' && action.payload.length > 0
            ? {
                type: 'video',
                id: action.payload[0].id,
              }
            : {
                ...state.overview,
              },
      }
    case FETCH_MORE_VIDEOS_FAILURE:
      return {
        ...state,
        shouldLoadMoreVideos: false,
      }

    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        isReady: false,
        isCategoriesReady: false,
      }
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        isReady: state.isParentsReady && state.isVideosReady,
        isCategoriesReady: true,
        categories: action.payload,
        focusedSection:
          state.focusedSection === '' && action.payload.length > 0
            ? 'categories'
            : state.focusedSection,
        focusedPosition: {
          ...state.focusedPosition,
          categories: 0,
        },
        overview:
          state.overview.type === 'unknown' && action.payload.length > 0
            ? {
                type: 'category',
                id: action.payload[0].id,
              }
            : {
                ...state.overview,
              },
      }
    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        isReady: state.isParentsReady && state.isVideosReady,
        isCategoriesReady: true,
        hasError: true,
        error: action.payload.message,
      }

    case FETCH_CATEGORY_VIDEOS_SUCCESS:
      if (
        typeof action.payload.videos !== 'undefined' &&
        action.payload.videos.length > 0
      ) {
        return {
          ...state,
          categoryVideos: {
            ...state.categoryVideos,
            [action.payload.categoryId]: action.payload.videos,
          },
          byId: newById(state, action.payload.videos),
          focusedPosition: {
            ...state.focusedPosition,
            [action.payload.categoryId]: 0,
          },
          overview:
            state.overview.type === 'unknown' && action.payload.videos.length > 0
              ? {
                  type: 'video',
                  id: action.payload[1].id,
                }
              : {
                  ...state.overview,
                },
        }
      } else {
        return state
      }

    case SET_FOCUSED_SECTION:
      return {
        ...state,
        focusedSection: action.payload,
        overview: newOverview(
          state,
          action.payload,
          state.focusedPosition[action.payload]
        ),
      }
    case SET_FOCUSED_POSITION:
      return {
        ...state,
        focusedPosition: {
          ...state.focusedPosition,
          [action.payload.status]: action.payload.position,
        },
        overview: newOverview(state, action.payload.status, action.payload.position),
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

const newById = (state, videos) => {
  const newById = {
    ...state.byId,
  }
  videos.forEach(video => {
    if (typeof newById[video.id] === 'undefined') {
      newById[video.id] = video
    }
  })
  return newById
}

const newOverview = (state, section, position) => {
  if (typeof state.focusedPosition[section] !== 'undefined') {
    switch (section) {
      case 'videos':
        return {
          type: 'video',
          id: state.videos[position],
        }
      case 'categories':
        return {
          type: 'category',
          id: position,
        }
      default:
        if (
          typeof state.categoryVideos[section] !== 'undefined' &&
          typeof state.categoryVideos[section][position] !== 'undefined'
        ) {
          return {
            type: 'video',
            id: state.categoryVideos[section][position].id,
          }
        }
    }
  }

  return {
    type: 'unknown',
    id: -1,
  }
}

export default videoLibraryReducer
